import { render, staticRenderFns } from "./NotificationCompanyUnbecomeDeputy.vue?vue&type=template&id=9ce660fa&scoped=true&lang=pug&"
import script from "./NotificationCompanyUnbecomeDeputy.vue?vue&type=script&lang=js&"
export * from "./NotificationCompanyUnbecomeDeputy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ce660fa",
  null
  
)

export default component.exports